import React, { useState } from "react";
import { Panel, Table } from "react-bootstrap";
import Moment from "react-moment";
import PhoneNumber from "../Shared/PhoneNumber";
import { Modal } from "react-bootstrap";
import Alert from "react-s-alert";

const CallRecordPanel = ({ callRecords }) => {
  const [showRecordings, setShowRecordings] = useState([]);

  const toggleMediaControls = id => {
    const current = [...showRecordings];
    if (current.indexOf(id) !== -1) {
      current.splice(current.indexOf(id), 1, id);
    } else {
      current.push(id);
    }
    setShowRecordings(current);
  };

  const showRecording = id => {
    return showRecordings.includes(id);
  };

  const [showTranscriptModal, setShowTranscriptModal] = useState(false);
  const [selectedTranscript, setSelectedTranscript] = useState("");

  const openTranscriptModal = call_record => {
    setSelectedTranscript(call_record.transcription);
    setShowTranscriptModal(true);
  };

  const closeTranscriptModal = () => {
    setShowTranscriptModal(false);
    setSelectedTranscript("");
  };

  return (
    <Panel bsStyle="success" className="compact-panel">
      <Panel.Heading>
        <Panel.Title componentClass="h3">Related Call Records</Panel.Title>
      </Panel.Heading>
      <Panel.Body style={{ padding: 3 }}>
        {callRecords && callRecords.length > 0 ? (
          <div style={{ overflowX: "auto" }}>
            <Table bordered condensed hover style={{ fontSize: 13 }}>
              <thead className="dark">
                <tr>
                  <th style={{ width: 10 }}>ID</th>
                  <th>At</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Recording</th>
                  <th>Transcript</th>
                  <th>Replit Score</th>
                </tr>
              </thead>
              <tbody>
                {callRecords.map((call_record, index) => {
                  return (
                    <tr key={index}>
                      <td data-label="ID">#{call_record.id}</td>
                      <td data-label="At">
                        <Moment format="MMM Do YYYY h:mma">
                          {call_record.at}
                        </Moment>
                      </td>
                      <td data-label="From">
                        {call_record.direction === "in" ? (
                          <span>
                            <PhoneNumber
                              number={call_record.contact_number}
                            ></PhoneNumber>
                          </span>
                        ) : (
                          <span style={{ wordBreak: "break-all" }}>
                            {call_record.m1_user_email}
                          </span>
                        )}
                      </td>
                      <td data-label="To">
                        {call_record.direction === "in" ? (
                          <span style={{ wordBreak: "break-all" }}>
                            {call_record.m1_user_email ||
                              (call_record.m1_number === "+61488851823"
                                ? "Emerson Line 1"
                                : call_record.m1_number === "+61489077741"
                                ? "Emerson Line 2"
                                : call_record.m1_number === "+61483961337"
                                ? "Emerson Line 3"
                                : call_record.m1_number === "+61488855574"
                                ? "Emerson Old"
                                : "")}
                          </span>
                        ) : (
                          <span>
                            <PhoneNumber
                              number={call_record.contact_number}
                            ></PhoneNumber>
                          </span>
                        )}
                      </td>
                      <td data-label="Recording">
                        {call_record.recording_url ? (
                          <div>
                            <div>
                              {
                                <button
                                  className="button-link"
                                  onClick={() =>
                                    toggleMediaControls(call_record.id)
                                  }
                                >
                                  {call_record.voicemail ? (
                                    <span>Voicemail</span>
                                  ) : (
                                    <span>
                                      {call_record.recording_call_status} (
                                      {call_record.recording_duration} seconds)
                                    </span>
                                  )}
                                </button>
                              }
                            </div>
                            {showRecording(call_record.id) && (
                              <audio
                                controls
                                style={{ width: 250, height: 32 }}
                              >
                                <source
                                  src={call_record.recording_url}
                                  type="audio/mp3"
                                />
                              </audio>
                            )}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </td>
                      <td data-label="Transcript">
                        {call_record.transcription ? (
                          <div style={{ display: "flex", gap: "5px" }}>
                            <button
                              onClick={() => openTranscriptModal(call_record)}
                              style={{
                                border: "none",
                                background: "none",
                                cursor: "pointer",
                                textDecoration: "underline"
                              }}
                            >
                              View
                            </button>
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  call_record.transcription
                                );
                                Alert.success("Transcript copied to clipboard!");
                              }}
                              style={{
                                border: "none",
                                background: "none",
                                cursor: "pointer",
                                textDecoration: "underline"
                              }}
                            >
                              Copy
                            </button>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </td>
                      <td data-label="Replit Score">
                        {call_record.replit_score !== null && call_record.replit_score !== undefined ? (
                          <div>
                            {call_record.replit_url ? (
                              <a
                                href={call_record.replit_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: call_record.replit_score >= 80 ? "#28a745" : 
                                         call_record.replit_score >= 60 ? "#ffc107" : "#dc3545",
                                  fontWeight: "bold"
                                }}
                              >
                                {call_record.replit_score.toFixed(1)}
                              </a>
                            ) : (
                              <span
                                style={{
                                  color: call_record.replit_score >= 80 ? "#28a745" : 
                                         call_record.replit_score >= 60 ? "#ffc107" : "#dc3545",
                                  fontWeight: "bold"
                                }}
                              >
                                {call_record.replit_score.toFixed(1)}
                              </span>
                            )}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          <div style={{ margin: 10 }}>No calls</div>
        )}
      </Panel.Body>

      <Modal
        show={showTranscriptModal}
        onHide={closeTranscriptModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Call Transcription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              background: "#f8f9fa",
              padding: "1rem",
              borderRadius: "8px",
              border: "1px solid #dee2e6",
              maxHeight: "500px",
              overflowY: "auto"
            }}
          >
            {selectedTranscript}
          </pre>
        </Modal.Body>
      </Modal>
    </Panel>
  );
};

export default CallRecordPanel;
